import React from "react";
import { withStyles } from "@material-ui/core/styles";
import withWidth, { isWidthDown } from "@material-ui/core/withWidth";
import classNames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ExpandIcon from "@material-ui/icons/CallMade";
import MinimizeIcon from "@material-ui/icons/CallReceived";
import styles from "./panel-jss";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

interface Props {
  classes?: any;
  openForm: boolean;
  closeForm: () => void;
  children: React.ReactNode;
  width: Breakpoint;
  title: string;
  extraSize?: boolean;
  paramSize?: string;
}

interface State {
  expanded: boolean;
}

class FloatingPanelClass extends React.Component<Props, State> {
  state = {
    expanded: false
  };

  private painel: HTMLElement | null = null;
  private focoAntesDeAbrir: HTMLElement | null = null;
  private focoPendente = false;

  componentDidMount() {
    if (this.props.openForm) {
      this.recebeFoco();
    }
  }

  componentDidUpdate(anteriores: Props) {
    if (!anteriores.openForm && this.props.openForm) {
      this.recebeFoco();
    } else if (anteriores.openForm && !this.props.openForm) {
      this.devolveFoco();
    }
  }

  private recebeFoco = () => {
    this.focoAntesDeAbrir = document.activeElement as HTMLElement | null;
    if (this.painel) {
      this.painel.focus();
      // no inicio da transicao o painel ainda esta com visibility hidden e o navegador ignora o focus
      this.focoPendente = document.activeElement !== this.painel;
    }
  };

  focaAoFimDaTransicao = (evento: React.TransitionEvent<HTMLElement>) => {
    const painel = evento.currentTarget;
    if (!this.focoPendente || evento.target !== painel || !this.props.openForm) {
      return;
    }
    this.focoPendente = false;
    if (!painel.contains(document.activeElement)) {
      painel.focus();
    }
  };

  private devolveFoco = () => {
    this.focoPendente = false;
    const origem = this.focoAntesDeAbrir;
    this.focoAntesDeAbrir = null;
    if (origem && document.body.contains(origem)) {
      origem.focus();
    }
  };

  // eventos do React borbulham pelos portals: o Esc que fecha o menu de um Select nao fecha o painel
  fechaComEsc = (evento: React.KeyboardEvent<HTMLElement>) => {
    const { openForm, closeForm } = this.props;
    if (openForm && evento.key === "Escape" && evento.currentTarget.contains(evento.target as Node)) {
      evento.stopPropagation();
      closeForm();
    }
  };

  toggleExpand = () => {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded });
  };

  render() {
    const { classes, openForm, closeForm, children, title, extraSize, width, paramSize = "large" } = this.props;
    const { expanded } = this.state;
    return (
      <div>
        <div
          className={classNames(
            classes.formOverlay,
            openForm && (isWidthDown("sm", width) || expanded) ? classes.showForm : classes.hideForm
          )}
        />
        <section
          className={classNames(
            !openForm ? classes.hideForm : classes.showForm,
            expanded ? classes.expanded : "",
            classes.floatingForm,
            classes.formTheme,
            extraSize && classes.large,
            !extraSize && classes[paramSize]
          )}
          style={{ padding: "20px" }}
          ref={(painel) => {
            this.painel = painel;
          }}
          tabIndex={-1}
          role="dialog"
          aria-label={title}
          onKeyDown={this.fechaComEsc}
          onTransitionEnd={this.focaAoFimDaTransicao}
        >
          <header>
            {title}
            <div className={classes.btnOpt}>
              <IconButton className={classes.expandButton} onClick={this.toggleExpand} aria-label="Expandir">
                {expanded ? <MinimizeIcon /> : <ExpandIcon />}
              </IconButton>
              <IconButton className={classes.closeButton} onClick={closeForm} aria-label="Fechar">
                <CloseIcon />
              </IconButton>
            </div>
          </header>
          {children}
        </section>
      </div>
    );
  }
}

const FloatingPanelResponsive = withWidth()(FloatingPanelClass);
const FloatingPanel = withStyles(styles as any)(FloatingPanelResponsive);
export default FloatingPanel;
